import http from '../utils/http';
import i18n from '@/main';

const URL_BASE = 'rastreabilidade/porto';

export default {
    getPortsPaginatedByFilter(body, page, size) {
        return http.post({
            url: `${URL_BASE}/buscar-porto-paginado?page=${page}&size=${size}`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoOperacoesArmazens')
        });
    },
    getTotalizers(portId) {
        let armazemVariable = '';
        if (portId !== null && portId !== 0) {
            armazemVariable = `?idArmazem=${portId}`;
        }
        return http.get({
            url: `${URL_BASE}/totalizadores${armazemVariable}`,
            lockScreen: false
        });
    }
};
